class AnnouncementBarElement extends HTMLElement {
    constructor() {
        super();
        this.closeButton = this.querySelector('.announcement-bar-close');
        this.closeBar = this.closeBar.bind(this);
    }

    connectedCallback() {
        if (this.closeButton) {
            this.closeButton.addEventListener('click', this.closeBar);
        }
    }

    disconnectedCallback() {
        if (this.closeButton) {
            this.closeButton.removeEventListener('click', this.closeBar);
        }
    }

    closeBar() {
        this.classList.add('hidden');
    }
}

if (!window.customElements.get("announcement-bar-element")) {
    window.customElements.define("announcement-bar-element", AnnouncementBarElement);
}

class CartQuantityDot extends HTMLElement {
    constructor() {
        super();
        this.quantityText = this.querySelector('.absolute-cart-quantity-icon-text');
        this.updateQuantityText();
    }

    connectedCallback() {
        document.addEventListener('cart:updated', this.updateQuantityText.bind(this));

        this.cartDrawer = document.querySelector('#cart-drawer');
        if (this.cartDrawer) {
            this.observer = new MutationObserver(this.updateQuantityText.bind(this));
            this.observer.observe(this.cartDrawer, { childList: true, subtree: true });
        }
    }

    disconnectedCallback() {
        document.removeEventListener('cart:updated', this.updateQuantityText.bind(this));

        if (this.observer) {
            this.observer.disconnect();
        }
    }

    updateQuantityText() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const totalQuantity = cart.items.reduce((total, item) => total + item.quantity, 0);
                this.quantityText.innerText = totalQuantity;
            })
            .catch(error => console.error('Error fetching cart data:', error));
    }
}

if (!window.customElements.get("cart-quantity-dot")) {
    window.customElements.define("cart-quantity-dot", CartQuantityDot);
}

class CustomMenuLinks extends HTMLElement {
    constructor() {
        super();
        this.menuHeading = this.querySelector('.custom-menu-links-heading');
        this.arrowDown = this.querySelector('.custom-menu-arrow-down');
        this.menuLinks = this.querySelector('.custom-menu-links-ul');

        this.toggleMenuLinks = this.toggleMenuLinks.bind(this);
    }

    connectedCallback() {
        this.menuHeading.addEventListener('click', this.toggleMenuLinks);
    }

    disconnectedCallback() {
        this.menuHeading.removeEventListener('click', this.toggleMenuLinks);
    }

    toggleMenuLinks() {
        this.arrowDown.classList.toggle('not-visible');
        this.menuLinks.classList.toggle('not-visible');
        this.menuHeading.classList.toggle('menu-links-visible');
    }
}

if (!window.customElements.get("custom-menu-links")) {
    window.customElements.define("custom-menu-links", CustomMenuLinks);
}

document.addEventListener('DOMContentLoaded', () => {
    const shadowHost = document.querySelector('.header-sidebar.drawer');
    
    if (shadowHost && shadowHost.shadowRoot) {
        const shadowRoot = shadowHost.shadowRoot;
    
        const logoImage = shadowRoot.querySelector('.contents .header__logo .header__logo-image');
        const srOnly = shadowRoot.querySelector('.contents .header__logo .sr-only');
    
        if (logoImage) {
            logoImage.style.width = '100%';
            logoImage.style.height = 'auto';
        }

        if (srOnly) {
            srOnly.style.display = 'none';
        }
    }
})